import { GiftCodeDto } from "@babackapp/private-api-client/types";
import { Badge } from "@babackapp/ui/components/badge";
import { ColumnDef } from "@tanstack/react-table";
import { formatDate } from "date-fns";
import GiftCodeDownloadButton from "./gift-code-download-button";

// TODO: useTranslation
export const columns: ColumnDef<GiftCodeDto>[] = [
  {
    accessorKey: "giftCode",
    header: "Code",
    cell: ({ row }) => {
      return <Badge variant="outline">{row.original.giftCode}</Badge>;
    },
  },
  {
    accessorKey: "orderName",
    header: "Order",
    cell: ({ row }) => {
      return <span className="font-medium">{row.original.orderName}</span>;
    },
  },
  {
    accessorKey: "usedAt-1",
    header: "Status",
    cell: ({ row }) => {
      const usedAt = row.original.usedAt;
      return usedAt ? (
        <Badge variant="outline">Used</Badge>
      ) : (
        <Badge variant="success-outline">Ready to be used</Badge>
      );
    },
  },
  {
    accessorKey: "usedAt-2",
    header: "Used at",
    enableSorting: true,
    sortingFn: () => 1,
    cell: ({ row }) => {
      const usedAt = row.original.usedAt;
      return usedAt ? (
        <span className="text-xs font-semibold text-muted-foreground">
          {formatDate(new Date(usedAt), "dd/MM/yyyy")}
        </span>
      ) : null;
    },
  },
  {
    accessorKey: "createdAt-1",
    header: "Created at",
    cell: ({ row }) => (
      <span className="text-xs font-semibold text-muted-foreground">
        {formatDate(new Date(row.original.createdAt), "dd/MM/yyyy")}
      </span>
    ),
  },
  {
    accessorKey: "createdAt-2",
    header: "Download",
    cell: ({ row }) => (
      <GiftCodeDownloadButton id={row.original.id} visible={true} />
    ),
  },
];
